<template>
  <div>
    <b-card title="">
      <p>
        شماره شما هنوز در هیچ شرکتی به عنوان کارمند ثبت نشده اید. اگه خودتان مدیر کسب و کاری هستید شرکت خود را اضافه کنید.</p>
      <br>
      <b-button
          variant="gradient-success"
          @click="addClick()"
      >ایجاد شرکت
      </b-button>
    </b-card>

  </div>
</template>

<script>
import {BButton, BCard, BCardText, BLink} from 'bootstrap-vue'
import router from "@/router";
import Config from "../../../config";

export default {
  components: {
    BCard,
    BCardText,
    BLink,
    BButton,
  },

  methods: {
    addClick() {
      router.push({ path: '/company/add' })
    },
  },
}
</script>

<style>

</style>
